import {useFactoryFetch} from "@/composables/useFactoryFetch.ts";
import {API_URLS, CrudEndpoints} from "@/utils/constants/api-urls.ts";
import {AfterFetchContext, MaybeRefOrGetter, UseFetchOptions} from "@vueuse/core";
import {ICreateExamRequest, IExam, IExamResult, IGetResult, ISubmitExamAnswersRequest, QueryFilter} from "@/types/api.ts";
import {useAxios} from "@vueuse/integrations/useAxios";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {computed, toValue} from "vue";
import {BaseService} from "@/services/base-service.ts";

export class ExamService extends BaseService<IExam> {
  endpoints: CrudEndpoints<IExam> = {};

  static getInstance(): ExamService {
    return new ExamService();
  }

  async updateExams(examsToUpdate: IExam[]) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.exams.updateExams, {
      method: "POST",
      data: {exams: examsToUpdate}
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data;
  }

  async submitExam(req: ISubmitExamAnswersRequest):Promise<IExamResult> {
    const {execute, data} = useAxios<IGetResult>(API_URLS.exams.submitExam(req.examId), {
      method: "POST",
      data: {answers: req.answers}
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data;
  }

  async createExam(body: ICreateExamRequest): Promise<void> {
    const {execute} = useAxios<IGetResult>(API_URLS.exams.create, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
  }

  getExams(query?: MaybeRefOrGetter<QueryFilter<IExam>>, options?: UseFetchOptions) {
    const url = computed<string>(() => {
      let s = API_URLS.exams.list(toValue(query));
      return s
    });
    return useFactoryFetch(url, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.data}
      },
      ...options
    }).json<IExam[]>();
  }

  async deleteExam(exam: IExam) {
    const {execute} = useAxios<IGetResult>(API_URLS.exams.deleteById(exam._id), {
      method: "DELETE",
    }, axiosInstance, {immediate: false})
    await execute();
  }

  getExamById(examId: IExam['_id']) {
    return useFactoryFetch(API_URLS.exams.getById(examId), {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.data}
      }
    }).get().json<IExam>();
  }
  getExamOrExamResult(examId: IExam['_id']) {
    return useFactoryFetch(API_URLS.exams.getExamOrExamResult(examId), {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.data}
      }
    }).get().json<IExam>();
  }

}